export enum TopicType {
    GoalPeriod = 1,
    Question = 2,
    GoalPeriodCustomGoals = 3,
    GoalAction = 4,
    Kpi = 5
}